import { render } from "./MatMeny.vue?vue&type=template&id=0d916da4"
import script from "./MatMeny.vue?vue&type=script&lang=js"
export * from "./MatMeny.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__